import { createContext, useContext } from 'react';

export interface SnackbarContextType {
  showSnackbar: (
    _message: string,
    _severity?: 'success' | 'error' | 'warning' | 'info',
    _duration?: number,
  ) => void;
  showSuccess: (_message: string, _duration?: number) => void;
  showError: (_message: string, _duration?: number) => void;
  showWarning: (_message: string, _duration?: number) => void;
  showInfo: (_message: string, _duration?: number) => void;
  hideSnackbar: () => void;
}

export const SnackbarContext = createContext<SnackbarContextType | undefined>(
  undefined,
);

export const useSnackbarContext = (): SnackbarContextType => {
  const context = useContext(SnackbarContext);
  if (!context) {
    throw new Error(
      'useSnackbarContext must be used within a SnackbarProvider',
    );
  }
  return context;
};
